import {
  dashboardStatsResponseSchema,
  needsAttentionResponseSchema,
  recentActivityResponseSchema,
} from 'xosign-types';

import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

const endpoints = {
  'dashboard.stats': {
    method: 'GET',
    url: `${API_URL_BASE}dashboard/stats`,
    requestSchema: z.undefined(),
    responseSuccessSchema: dashboardStatsResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    z.ZodUndefined,
    typeof dashboardStatsResponseSchema,
    z.ZodUndefined
  >,
  'dashboard.needsAttention': {
    method: 'GET',
    url: `${API_URL_BASE}dashboard/needs-attention`,
    requestSchema: z.undefined(),
    responseSuccessSchema: needsAttentionResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    z.ZodUndefined,
    typeof needsAttentionResponseSchema,
    z.ZodUndefined
  >,
  'dashboard.recentActivity': {
    method: 'GET',
    url: `${API_URL_BASE}dashboard/recent-activity`,
    requestSchema: z.undefined(),
    responseSuccessSchema: recentActivityResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    z.ZodUndefined,
    typeof recentActivityResponseSchema,
    z.ZodUndefined
  >,
} as const;

export default endpoints;
